import React, { FC } from 'react';

import FooterContent from './Content';

type FooterProps = {
  className?: string;
};

const Footer: FC<FooterProps> = ({
  className,
}) => {
  return (
    <FooterContent className={className} />
  );
};

export default Footer;
